module.exports = __webpack_public_path__ + "static/media/logo.a5358c5f.png";